(function () {
    'use strict';

    angular
        .module('app')
        .controller('RoleListController', lController);

    function lController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state, $filter, RoleService, toaster) {
        var model = this;
       
        $scope.editRole = function (roleId) {
            $state.go('roleEdit', { roleId: roleId })
        };

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }
    }
})();

